import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const ImagePreview = ({ onDelete, onSetPrimaryIndex, imgSrc, index, primaryImage }) => {
  const intl = useIntl();
  const [showActions, setShowActions] = useState(false);
  const onMouseOver = () => {
    setShowActions(true);
  };

  const onMouseLeave = () => {
    setShowActions(false);
  };
  return (
    <div
      className={classNames('img-wrapper', { 'show-actions': showActions, 'primary-image': primaryImage })}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
    >
      {primaryImage && <span className="primary-flag">{intl.formatMessage({ id: 'image-upload.primary' })}</span>}
      <img src={imgSrc} />
      <div className="actions">
        <span
          onClick={() => {
            onSetPrimaryIndex && onSetPrimaryIndex(index);
          }}
        >
          {primaryImage && (
            <span key="fas">
              <ion-icon name="star"></ion-icon>
            </span>
          )}
          {!primaryImage && (
            <span key="far">
              <ion-icon name="star-outline"></ion-icon>
            </span>
          )}
        </span>
        <span
          onClick={() => {
            onDelete && onDelete(imgSrc);
          }}
        >
          <ion-icon name="trash-outline"></ion-icon>
        </span>
      </div>
    </div>
  );
};

ImagePreview.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  onDelete: PropTypes.func,
  onSetPrimaryIndex: PropTypes.func,
  primaryImage: PropTypes.bool,
  index: PropTypes.number.isRequired,
};

export default ImagePreview;
